import { Platform } from "core/hooks/useMobilePlatform";

export enum TrackerType {
  Sleep = 1,
  Steps = 2,
  Activity = 3,
  Water = 4,
  BreathingExercises = 5,
}

export enum StreakStatusType {
  FirstStreak = "first_streak",
  NewStreak = "new_streak",
  Active = "active",
  Zero = "zero",
}

export const platformHealthTrackerTypes: Record<Platform, TrackerType[]> = {
  [Platform.android]: [TrackerType.Steps],
  [Platform.ios]: [TrackerType.Steps, TrackerType.Sleep, TrackerType.Water],
};

export const toTrackerType = (trackerIdentifier: string): TrackerType => {
  const trackerType = Object.keys(TrackerType).find((type) => type.toLowerCase() === trackerIdentifier.toLowerCase());
  if (trackerType === undefined) {
    throw new Error(`Could not find a TrackerType using tracker identifier of: ${trackerIdentifier}`);
  }
  return TrackerType[trackerType as keyof typeof TrackerType];
};

export const isTrackerForPlatform = (trackerType: TrackerType, platform: Platform): boolean =>
  platformHealthTrackerTypes[platform].some((platformTracker) => platformTracker === trackerType);

export const isTrackerTypePermissionAllowed = (trackerType: TrackerType, syncedTrackers: string[]) =>
  syncedTrackers.some((pt) => pt.toLowerCase() === TrackerType[trackerType].toLowerCase());
